document.addEventListener("DOMContentLoaded",()=>{

const observer=new IntersectionObserver((entries)=>{

entries.forEach((entry)=>{

if(entry.isIntersecting){

entry.target.classList.add("visible");

}

});

},{threshold:.25});

document.querySelectorAll(".collage__item").forEach((card)=>{

card.classList.add("fade-up");

observer.observe(card);

});

});
document.addEventListener('DOMContentLoaded',()=>{

const observer=new IntersectionObserver((entries)=>{

entries.forEach(entry=>{

if(entry.isIntersecting){

entry.target.classList.add('is-visible');

}

});

},{
threshold:.15
});

const cards=document.querySelectorAll('.mision-collage-item');

cards.forEach((card,index)=>{

card.classList.add('nereo-reveal');

card.classList.add(`nereo-delay-${index+1}`);

observer.observe(card);

});

});